import { createDedupedAjaxRequest } from './tabulatorProgressiveLoading';

/** Remote progressive lists: header filters collect values only; server filters rows. */
export function serviceTaskRemoteHeaderFilterAlwaysTrue() {
  return true;
}

export function appendServiceTaskToolbarSearch(extra, submittedSearchValueRef) {
  const search = String(submittedSearchValueRef?.current ?? '').trim();
  if (search !== '') extra.toolbar_search = search;
  return extra;
}

/**
 * Wrap deduped ajax with generation guard — stale responses return empty page payload.
 */
export function createServiceTaskGenerationAwareAjaxRequest({
  getBuildRequestParams,
  fetchPaged,
  inFlightRef,
  completedCacheRef,
  isRestoringRef,
  lastResponseRef,
  ajaxGenerationRef,
  applyResponseOverlay,
}) {
  const baseRequest = createDedupedAjaxRequest(
    getBuildRequestParams,
    fetchPaged,
    inFlightRef,
    completedCacheRef,
    isRestoringRef,
    lastResponseRef,
  );
  return (url, config, params) => {
    const generation = ajaxGenerationRef.current;
    return baseRequest(url, config, params).then((data) => {
      if (generation !== ajaxGenerationRef.current) {
        return {
          data: [],
          last_page: data?.last_page ?? 1,
          total: 0,
          current_page: Number(params?.page) || 1,
        };
      }
      return typeof applyResponseOverlay === 'function' ? applyResponseOverlay(data) : data;
    });
  };
}
